export const PATH = {
    admin: '/',
    no_connection: '/no-connection',
    not_found: '/notfound',
    forbidden: '/forbidden',
    visma: '/visma/',
    distributor: '/distributor/',
    user: '/user/',
    tasks: '/tasks/',
    visma_support: '/visma/support',
    visma_support_companies: '/visma/support/companies',
    distributor_support: '/distributor/support',
    distributor_support_companymove: '/distributor/support/companymove',
    user_details: '/user/details',
    user_details_myroles: '/user/details/myroles',
    user_details_mymobiletokens: '/user/details/mymobiletokens',
    user_details_mylinkedusers: '/user/details/mylinkedusers'
}
